<template>
  <div class="aws-sku-wrapper">
    <div class="aws-sku-banner">
      <AwsSkuDescriptions :data="data" />

      <AwsSkuSwitchTabs v-model="currentTab" :options="tabOptions" />
    </div>

    <div class="aws-sku-pane">
      <div v-if="currentTab == 'AwsSkuBaseInfo'">
        <AwsSkuBaseInfo
          ref="skuBase"
          :disabled="disabled"
          :isCopy="isCopy"
          :isSpuCopy.sync="newIsSpuCopy"
          :amzSkuCode.sync="newAmzSkuCode"
          :amzSpuCode="amzSpuCode"
          :form="form"
          :amzSkuStatus.sync="amzSkuStatus"
          @reload="getData"
        />

        <div class="d-flex justify-content-end mb-2 mt-2" v-if="!disabled">
          <el-button type="primary" size="small" @click="$refs.skuBase.save()">
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </div>

      <div v-if="currentTab == 'AwsSkuProductSpec'">
        <AwsSkuProductSpec
          :amzSkuCode="newAmzSkuCode"
          :disabled="disabled"
          :isFormal="isFormal"
          :isSingle="isSingle"
          :sku="data"
          @reload="getData"
        />
      </div>

      <div v-if="currentTab == 'AwsSkuFabric'">
        <AwsSkuFabric
          :disabled="disabled || isFormal"
          :amzSkuCode="newAmzSkuCode"
        />
      </div>

      <!-- <div v-if="currentTab == 'AwsSkuSewingMaterials'">
        <AwsSkuSewingMaterials
          :disabled="disabled"
          :isFormal="isFormal"
          :amzSkuCode="newAmzSkuCode"
        />
      </div> -->

      <!-- <div v-if="currentTab == 'AwsSkuPackagingMaterials'">
        <AwsSkuPackagingMaterials
          :disabled="disabled"
          :amzSkuCode="newAmzSkuCode"
          :isFormal="isFormal"
        />
      </div> -->

      <div v-if="currentTab == 'AwsSkuTechDescription'">
        <AwsSkuTechDescription
          :disabled="disabled"
          :amzSkuCode="newAmzSkuCode"
        />
      </div>

      <div v-if="currentTab == 'AwsSkuProductFactory'">
        <AwsSkuProductFactory
          :disabled="disabled"
          :amzSkuCode="newAmzSkuCode"
          @reloadSku="$refs.skuBase.reloadSku()"
        />
      </div>

      <div v-if="currentTab == 'AwsSkuProductImages'">
        <AwsSkuProductImages
          :disabled="disabled"
          :amzSkuCode="newAmzSkuCode"
          @reload="getData"
        />
      </div>

      <div v-if="currentTab == 'AwsSkuSalesChannels'">
        <AwsSkuSalesChannels
          :disabled="disabled || amzSkuStatus === 'Q'"
          :amzSkuCode="newAmzSkuCode"
        />
      </div>
    </div>
  </div>
</template>
<script>
import AwsSkuDescriptions from '../aws-sku-descriptions'
import AwsSkuSwitchTabs from '../aws-sku-switch-tabs'
import AwsSkuBaseInfo from '../aws-sku-base-info'
import AwsSkuProductSpec from '../aws-sku-product-spec'
import AwsSkuFabric from '../aws-sku-fabric'
import AwsSkuSewingMaterials from '../aws-sku-sewing-materials'
import AwsSkuPackagingMaterials from '../aws-sku-packaging-materials'
import AwsSkuTechDescription from '../aws-sku-tech-description'
import AwsSkuProductFactory from '../aws-sku-product-factory'
import AwsSkuProductImages from '../aws-sku-product-images'
import AwsSkuSalesChannels from '../aws-sku-sales-channels'
export default {
  components: {
    AwsSkuDescriptions,
    AwsSkuSwitchTabs,
    AwsSkuBaseInfo,
    AwsSkuProductSpec,
    AwsSkuFabric,
    AwsSkuSewingMaterials,
    AwsSkuPackagingMaterials,
    AwsSkuTechDescription,
    AwsSkuProductFactory,
    AwsSkuProductImages,
    AwsSkuSalesChannels,
  },
  props: {
    disabled: { type: Boolean, default: false },
    isCopy: { type: Boolean, default: false },
    isSpuCopy: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    amzSpuCode: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      currentTab: 'AwsSkuBaseInfo',
      amzSkuStatus: '',
      newAmzSkuCode: '',
      newIsSpuCopy: false,
      data: {},
    }
  },
  computed: {
    tabOptions() {
      return [
        {
          label: this.$l('INDEX.tab_pane_label_awsSkuInfo') || '基本信息',
          value: 'AwsSkuBaseInfo',
        },
        {
          label:
            this.$l('INDEX.tab_pane_label_awsSkuProductSpec') || '产品规格',
          value: 'AwsSkuProductSpec',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
        {
          label: this.$l('INDEX.tab_pane_label_awsSkuFabric') || '面料构成',
          value: 'AwsSkuFabric',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
        // {
        //   label: this.$l('INDEX.tab_pane_label_awsSkuSewingMaterials') || '缝制辅料',
        //   value: 'AwsSkuSewingMaterials',
        //   disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        // },
        // {
        //   label: this.$l('INDEX.tab_pane_label_awsSkuPackagingMaterials') || '包装辅料',
        //   value: 'AwsSkuPackagingMaterials',
        //   disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        // },
        {
          label:
            this.$l('INDEX.tab_pane_label_awsSkuTechDescription') || '工艺说明',
          value: 'AwsSkuTechDescription',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
        {
          label:
            this.$l('INDEX.tab_pane_label_awsSkuProductFactory') || '生产厂家',
          value: 'AwsSkuProductFactory',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
        {
          label:
            this.$l('INDEX.tab_pane_label_awsSkuProductImages') || '产品图片',
          value: 'AwsSkuProductImages',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
        {
          label:
            this.$l('INDEX.tab_pane_label_awsSkuSalesChannels') || '销售渠道',
          value: 'AwsSkuSalesChannels',
          disabled: !this.newAmzSkuCode || this.newIsSpuCopy,
        },
      ]
    },
    isSingle() {
      return this.data.skuPackSize == 'single'
    },
    isFormal() {
      // return this.data.amzSkuStatus == 'Y'
      return false
    },
  },
  watch: {
    amzSkuCode: {
      handler(e) {
        if (e) this.newAmzSkuCode = e
      },
      immediate: true,
    },
    isSpuCopy: {
      handler(e) {
        if (e) this.newIsSpuCopy = e
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.newAmzSkuCode) return

      const res = await this.$api
        .ecomAmzSkuDetailApi({ amzSkuCode: this.newAmzSkuCode })
        .catch(() => null)
      if (!res) return

      this.data = res.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-banner {
  border-radius: 5px;
  padding: 16px 16px 0;
  background-color: #ffffff;
  margin-bottom: 10px;
}

.aws-sku-pane {
  border-radius: 5px;
  padding: 16px;
  background-color: #ffffff;
}
</style>
